import { Modal, Box, Typography, Button, Card, Divider, Grid } from "@mui/material";
import { convertDateTimeToTz } from "../../../utils/helper/timeHelpers";
import { LABEL_TYPE, TIMEZONE } from "../../../utils/Constant";
import Label from "../../../comman/Label";
import { formatFileURL } from "../../../utils/helper/appHelpers";
import logo from "../../../assets/profile.png";

const CustomerDetailsModal = ({ open, onClose, customerData = {} }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
          width: "65%",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Customer Details
        </Typography>


          <Grid container spacing={3}>
    
            <Grid item md={8} xs={12}>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <Typography variant="caption">User Name</Typography>
                  <Typography variant="subtitle2">
                    {customerData?.userName || "-"}
                  </Typography>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Typography variant="caption">Email</Typography>
                  <Typography variant="subtitle2">
                    {customerData?.email || "-"}
                  </Typography>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Typography variant="caption">Mobile</Typography>
                  <Typography variant="subtitle2">
                    {customerData?.dialCode} {customerData?.mobileNo}
                  </Typography>
                </Grid>

                <Grid item md={6} xs={12}>
                  <Typography variant="caption">Registered On</Typography>
                  <Typography variant="subtitle2">
                    {customerData?.createdAt
                      ? convertDateTimeToTz(
                          customerData.createdAt,
                          TIMEZONE["America/Toronto"],
                          "DD MMM, YYYY"
                        )
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item md={4} xs={12}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
              >
                <Box
                  component="img"
                  src={
                    customerData?.profilePic
                      ? formatFileURL(customerData.profilePic)
                      : logo
                  }
                  sx={{
                    height: 90,
                    width: 90,
                    borderRadius: 2,
                    boxShadow: 2,
                    mb: 1,
                  }}
                />

                <Label type={LABEL_TYPE.STATUS} value={customerData?.status}>
                  {customerData?.status}
                </Label>
              </Box>
            </Grid>
          </Grid>
        

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button variant="contained" size="small" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomerDetailsModal;
